//* 선택유닛이 어떤 원상품(GiftItemInfo)에 걸려 있는지 뒤집어 보는 유틸.
//* 유닛 기준 역조회 API가 없어 상품 목록을 한 번 읽고 프론트에서 맵으로 만든다.

//* 상품 목록에서 필요한 필드만 (select=name isEnabled choiceUnits priceRetail priceRegular priceWhole)
export interface GiftItemInfoUsageLite {
  _id: string;
  name: string;
  isEnabled?: boolean;
  choiceUnits?: (string | { _id: string })[];
  priceRetail?: number;
  priceRegular?: number;
  priceWhole?: number;
}

/** 상품 칩에 붙일 가격 — 판매가 우선, 없으면 정가 */
export const usageChipPrice = (info: GiftItemInfoUsageLite): number | null =>
  info.priceRetail || info.priceRegular || null;

/** 칩 툴팁 문구 — 판매상태 + 정가/판매가/도매가 */
export const usageChipTitle = (info: GiftItemInfoUsageLite): string => {
  const won = (v?: number) => (v ? `${v.toLocaleString()}원` : '-');
  return [
    info.isEnabled === false ? '판매종료 상품' : '판매중 상품',
    `정가 ${won(info.priceRegular)}`,
    `판매가 ${won(info.priceRetail)}`,
    `도매가 ${won(info.priceWhole)}`,
  ].join(' · ');
};

/** 판매중(isEnabled !== false) 상품을 앞으로, 그다음 이름순 */
const byOnSaleThenName = (a: GiftItemInfoUsageLite, b: GiftItemInfoUsageLite) =>
  Number(b.isEnabled !== false) - Number(a.isEnabled !== false) ||
  a.name.localeCompare(b.name);

/**
 * 선택유닛 _id → 이 유닛을 선택지로 가진 상품 목록.
 * choiceUnits는 select만 걸면 문자열 id지만, populate된 응답도 그대로 받는다.
 */
export const buildUnitUsageMap = (
  itemInfoList: GiftItemInfoUsageLite[],
): Map<string, GiftItemInfoUsageLite[]> => {
  const map = new Map<string, GiftItemInfoUsageLite[]>();

  itemInfoList.forEach((info) => {
    info.choiceUnits?.forEach((unit) => {
      const unitId = typeof unit === 'object' ? unit?._id : unit;
      if (!unitId) return;
      const list = map.get(unitId);
      if (list) list.push(info);
      else map.set(unitId, [info]);
    });
  });

  map.forEach((list) => list.sort(byOnSaleThenName));

  return map;
};
